import React, { useEffect } from 'react';
// import clsx from 'clsx';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { useStoreState, useStoreActions } from 'easy-peasy';
import {
  AppBar,
  Toolbar,
  List,
  Typography,
  IconButton,
  ListItemText,
  Container,
  Tooltip,
  Collapse,
  Snackbar,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withRouter } from 'react-router-dom';
import HomeIcon from '@material-ui/icons/Home';
import { routes } from '../../routes/routes';
import { ChangePasswordPage } from '../../pages';
import { SubmitSnackbar } from '../../components';
import { globalDateEntity, ssoLoginEntity } from '../../constants/applicationConstants';
import { PRODUCTS, ROLES } from '../../submodule';
import LocalStorageService from '../../services/localStorage';
import npmPackage from '../../../package.json';
import manifest from '../../server-version-info/api-manifest.json';
import SettingsIcon from '@material-ui/icons/Settings';
import AssessmentIcon from '@material-ui/icons/Assessment';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Avatar from '@material-ui/core/Avatar';
import './baseStyle.css';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import { sortDataList } from '../../submodule';
import useCommonAuth from '../../submodule/hooks/useCommonAuth';

const customStyles = (theme) => ({
  root: {
    margin: '0px 16px',
    padding: '24px 24px 0px',
    backgroundColor: 'transparent',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(2),
    color: 'rgba(0, 0, 0, 0.87)',
  },
});

const DialogTitle = withStyles(customStyles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ color: 'rgba(0, 0, 0, 0.87)' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

/** STYLES HERE * */
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100%',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(0),
    margin: '64px 0px 0px',
    overflow: 'auto',
    width: '100%',
    maxWidth: '100%',
    backgroundColor: '#fff',
  },
  apart: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-between',
  },
  title: {
    color: 'white',
  },
  purple: {
    color: 'white',
  },
  profileAvatar_medium: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  ['@media print']: {
    content: {
      display: 'none !important',
    },
    toolbar: {
      display: 'none !important',
    },
    appBar: {
      display: 'none !important',
    },
    root: {
      display: 'none !important',
    },
  },
}));

const MiniDrawer = (props) => {
  const classes = useStyles();
  const { hasSettingsMenuAccess } = useCommonAuth();
  const routState = useStoreState((state) => state.common.drawerState);
  const routAction = useStoreActions((actions) => actions.common);
  const loggedInUserInfo = useStoreState((state) => state.login.userInfo);
  const loginAction = useStoreActions((actions) => actions.login);
  const orgAction = useStoreActions((actions) => actions.organization);
  const configData = useStoreState((state) => state.customize.configData);
  const reportAction = useStoreActions((actions) => actions.report);
  const reportState = useStoreState((state) => state.report);
  const [open_report, setOpenReport] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [pwdChange, setPwdChange] = React.useState(false);
  const [avatarLabel, setAvatarLabel] = React.useState('');
  const [menuDrawer, setMenuDrawer] = React.useState(null);
  const [settingsMenuDrawer, setSettingsMenuDrawer] = React.useState(null);
  const [analyticsMenuDrawer, setAnalyticsMenuDrawer] = React.useState(null);
  const [snacksOpen, setSnacksOpen] = React.useState(false);
  const [snacksMsg, setSnacksMsg] = React.useState('');
  const [filePath, setFilePath] = React.useState('');
  const [intervalClear, setIntervalClear] = React.useState();

  const localStorageService = LocalStorageService.getService();

  const handleMenuMouseHover = (event) => {
    if (menuDrawer !== event.currentTarget) {
      setMenuDrawer(event.currentTarget);
    }
  };
  // Report download notification snackbar funtionality
  const handleSnacksClose = () => {
    setSnacksOpen(false);
  };
  const downloadReportDirectly = (event, filePath) => {
    event.preventDefault();
    if (filePath) {
      reportAction
        .getPreSignedUrl({
          filename: filePath.filePath,
          operation_type: 'DOWNLOAD',
        })
        .then(function (response) {
          window.open(response.data.data.url);
        })
        .catch(function (error) {
          commonAction.setSubmitSnackbar({
            status: true,
            messages: stringConstants.fileDownloadFailureMsg,
            error: true,
          });
        });
    }
  };

  const handleSettingsMouseHover = (event) => {
    if (settingsMenuDrawer !== event.currentTarget) {
      setSettingsMenuDrawer(event.currentTarget);
    }
  };

  const handleAnalyticsMouseHover = (event) => {
    if (analyticsMenuDrawer !== event.currentTarget) {
      setAnalyticsMenuDrawer(event.currentTarget);
    }
  };

  const pushSettingsMenu = (url) => {
    setSettingsMenuDrawer(null);
    props.history.push(url);
  };

  const handleSetingsMenuClose = () => {
    setSettingsMenuDrawer(null);
  };

  const handleAnalyticsMenuClose = () => {
    setAnalyticsMenuDrawer(null);
  };

  const handleMenuClose = () => {
    setMenuDrawer(null);
  };

  const handleClickReport = () => {
    setOpenReport(!open_report);
  };

  const handleAccountClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleAccountClose = () => {
    setAnchorEl(null);
  };

  const StyledMenu = withStyles({
    paper: {
      border: '1px solid #d3d4d5',
      top: '64px !important',
      minWidth: '260px',
      borderRadius: '15px',
      borderTopRightRadius: '0px',
      borderTopLeftRadius: '0px',
    },
    list: {
      padding: '0px',
    },
  })((props) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      {...props}
    />
  ));

  const StyledMenuItem = withStyles((theme) => ({
    root: {
      borderBottom: '1px solid #d3d4d5',
      '&last-child': {
        borderBottom: '0px solid #d3d4d5',
      },
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
          color: theme.palette.common.white,
        },
      },
    },
  }))(MenuItem);

  useEffect(() => {
    const enabledRoutes = [];
    orgAction.setOrgsID(loggedInUserInfo.orgs_id);
    routes.forEach((route, index) => {
      if(route.role?.includes(loggedInUserInfo?.roles?.sso_title)){
        enabledRoutes.push(route);
      }      
    });
    if (enabledRoutes.length) {
      routAction.setDrawer(enabledRoutes);
    }

    if (loggedInUserInfo && loggedInUserInfo.roles) {
      if (
        window.location.pathname.includes('events')
      ) {
        setOpenReport(true);
      }
    }

    if (loggedInUserInfo != null && loggedInUserInfo != undefined) {
      let nameInitials = '';
      if (loggedInUserInfo?.firstname?.length > 0) {
        nameInitials = loggedInUserInfo.firstname[0].toUpperCase();
      }
      if (loggedInUserInfo?.lastname?.length > 0) {
        nameInitials =
          nameInitials + loggedInUserInfo.lastname[0].toUpperCase();
      }
      setAvatarLabel(nameInitials);
    }
  }, [loggedInUserInfo]);

  // LOGOUT METHOD
  const logout = async () => {
    if(loggedInUserInfo && loggedInUserInfo.is_sso_user && loggedInUserInfo.is_sso_user.toUpperCase() == 'Y') {
      // await loginAction.logoutSSO(loggedInUserInfo);      
      if(localStorageService.getProvider() && localStorageService.getProvider() === "okta") {
        await loginAction.logout(loggedInUserInfo);
        setTimeout(() => {
          window.location.href = ssoLoginEntity.ssoLogoutUrl;
        }, 1000);
      } else if(localStorageService.getProvider() && localStorageService.getProvider() === "azure") {
        LocalStorageService.clearToken();
        setTimeout(function () {
          window.location = '/login';
        }, 500);
      } else {
        LocalStorageService.clearToken();
        setTimeout(function () {
          window.location = '/login';
        }, 500);
      }
    } else {
      await loginAction.logout(loggedInUserInfo);
      // window.location = '/';
    }
  };

  // On Click event
  const handleClick = (event, route) => {
    props.history.push(route.path);
  };

  let dataArr = [];
  const menuList =
    routState &&
    routState.length > 0 &&
    sortDataList(routState, 'label', true).map((route, index) => {
      if (route?.asMenu) {
        if (route.child) {
          dataArr.push(
            <StyledMenuItem
              key={index}
              onClick={(event) => {
                handleClick(event, route);
              }}
            >
              <ListItemText primary={route.label} />
            </StyledMenuItem>,
          );
          return;
        }
        if (route.is_parent) {
          return (
            <>
              <StyledMenuItem button onClick={handleClickReport} key={index}>
                <ListItemText primary="Analytics" />
              </StyledMenuItem>
              <Collapse in={open_report} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {dataArr}
                </List>
              </Collapse>
            </>
          );
        } else {
          return (
            <StyledMenuItem
              key={index}
              onClick={(event) => {
                handleClick(event, route);
              }}
            >
              <ListItemText primary={route.label} />
            </StyledMenuItem>
          );
        }
      }
    });

  const handleClickOpen = (opt) => {
    setAnchorEl(false);
    if (opt === 'change_password') {
      setPwdChange(true);
      return;
    }
  };

  const hideModalWindow_pwdChange = () => {
    setPwdChange(false);
  };
  // Report download notification snackbar funtionality
  const action = (
    <React.Fragment>
      <Typography
        style={{
          textDecoration: 'underline',
          cursor: 'pointer',
          fontSize: '14px',
          marginRight: '10px',
        }}
        onClick={(event) => downloadReportDirectly(event, { filePath })}
      >
        Download Report
      </Typography>
      <IconButton
        size="small"
        aria-label="close"
        style={{ color: 'white' }}
        onClick={handleSnacksClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  React.useEffect(() => {
    if (localStorageService.getNotification() === 'true') {
      setIntervalClear(
        setInterval(() => {
          reportAction
            .userNotifications()
            .then(function (response) {})
            .catch(function (error) {
              console.log(error);
              setSnacksOpen(true);
              setSnacksMsg(error.response.data.error);
              setFilePath('');
            });
        }, 15000),
      );
      return () => {
        clearInterval(intervalClear);
      };
    }
  }, [localStorageService.getNotification()]);
  React.useEffect(() => {
    const temp = reportState.userNotificationsList?.data?.data?.data;

    if (temp?.length > 0 && localStorageService.getNotification() === 'true') {
      clearInterval(intervalClear);
      reportAction.setReportFileUrl([]);
      localStorageService.clearNotification();
      temp?.map((e) => {
        if (
          e.status === 0 &&
          e.notification_type === 'download_data_report_notification'
        ) {
          setSnacksOpen(true);
          setSnacksMsg(e.message);
          setFilePath(e.file_path);
        }
      });
    }
  }, [reportState.userNotificationsList]);
  // Report download notification snackbar funtionality

  return (
    <div className={classes.root}>
      <AppBar position="fixed" style={{ boxShadow: 'none' }}>
        <Toolbar disableGutters={true}>
          {(loggedInUserInfo &&
            loggedInUserInfo.roles &&
            loggedInUserInfo.roles.sso_title &&
            (loggedInUserInfo.roles.sso_title !== ROLES.AUTO_ADMIN && loggedInUserInfo.roles.sso_title !== ROLES.AUTO_OPERATOR && loggedInUserInfo.roles.sso_title !== ROLES.AUTO_USER)) && (
              <IconButton
                style={{ alignSelf: 'center' }}
                color="inherit"
                aria-label="open drawer"
                onMouseOver={handleMenuMouseHover}
              >
                <MenuIcon />
              </IconButton>
          )}
          <div className={classes.apart}>
            <div style={{ display: 'flex' }}>
              <Typography
                variant="h6"
                style={{
                  cursor: 'pointer',
                  alignSelf: 'center',
                  paddingLeft: '16px',
                  color: localStorageService.getFontColor()
                    ? localStorageService.getFontColor()
                    : globalDateEntity.primaryFontColor,
                }}
                className={classes.title}
                noWrap
                onClick={() => props.history.push(`/`)}
              >
                {configData &&
                configData.preferences &&
                configData.preferences.custom_branding
                  ? configData.preferences.custom_branding
                  : globalDateEntity.siteHeaderTitle}
              </Typography>
            </div>
            <div>
              <IconButton
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={() => {
                  props.history.push('/');
                }}
              >
                <Tooltip title="Home">
                  <HomeIcon style={{ fontSize: 32 }} className={classes.purple}>
                    Home
                  </HomeIcon>
                </Tooltip>
              </IconButton>
              {loggedInUserInfo &&
                loggedInUserInfo.roles &&
                loggedInUserInfo.roles.sso_title === ROLES.TENANT_ADMIN && (
                  <IconButton
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleAnalyticsMouseHover}
                    onMouseOver={handleAnalyticsMouseHover}
                  >
                    <Tooltip title="Analytics">
                      <AssessmentIcon
                        style={{ fontSize: 32 }}
                        className={classes.purple}
                      >
                        Analytics
                      </AssessmentIcon>
                    </Tooltip>
                  </IconButton>
                )}
              {(hasSettingsMenuAccess(
                PRODUCTS.MAINAPP,
                loggedInUserInfo?.roles?.sso_title,
              ) ||
                loggedInUserInfo?.roles?.sso_title ===
                  ROLES.PLATFORM_ADMIN) && (
                <>
                  <IconButton
                    style={{ cursor: 'pointer' }}
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleSettingsMouseHover}
                    onMouseOver={handleSettingsMouseHover}
                  >
                    <Tooltip title="Settings">
                      <SettingsIcon
                        style={{ fontSize: 32 }}
                        className={classes.purple}
                      >
                        Settings
                      </SettingsIcon>
                    </Tooltip>
                  </IconButton>
                </>
              )}

              <IconButton
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleAccountClick}
                // onMouseOver={handleAccountClick}
              >
                <Avatar
                  style={{ backgroundColor: 'white', color: 'black' }}
                  className={classes.profileAvatar_medium}
                >
                  <Typography
                    variant="body2"
                    style={{ fontWeight: 'bold', fontSize: 'medium' }}
                  >
                    {avatarLabel}
                  </Typography>
                </Avatar>
              </IconButton>

              <StyledMenu
                id="customized-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleAccountClose}
              >
                <StyledMenuItem
                  style={{ backgroundColor: 'lightgrey', cursor: 'default' }}
                >
                  <ListItemText
                    primaryTypographyProps={{
                      style: {
                        fontSize: 'small',
                        fontWeight: '700',
                        color: '#958181',
                      },
                    }}
                    primary={
                      <div style={{ maxWidth: '11vw' }}>
                        <Tooltip placement="left" title={``}>
                          <Typography
                            disabled
                            style={{
                              fontSize: 'small',
                              fontWeight: '700',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {' '}
                            {loggedInUserInfo?.orgs_title}
                          </Typography>
                        </Tooltip>
                      </div>
                    }
                  />
                </StyledMenuItem>
                <StyledMenuItem onClick={handleClickOpen}>
                  <ListItemText
                    primaryTypographyProps={{
                      style: { fontSize: 'small', fontWeight: '700' },
                    }}
                    primary={
                      <>
                        <div
                          style={{
                            maxWidth: '11vw',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          <Tooltip placement="left" title={``}>
                            <Typography
                              style={{
                                fontSize: 'small',
                                fontWeight: '700',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {' '}
                              {loggedInUserInfo?.firstname +
                                ' ' +
                                loggedInUserInfo?.lastname}
                            </Typography>
                          </Tooltip>
                        </div>
                      </>
                    }
                  ></ListItemText>
                </StyledMenuItem>
                {loggedInUserInfo && loggedInUserInfo.is_sso_user && loggedInUserInfo.is_sso_user.toUpperCase() == 'Y' ? (<></>) : (
                  <StyledMenuItem
                    onClick={() => handleClickOpen('change_password')}
                  >
                    <ListItemText
                      primaryTypographyProps={{
                        style: { fontSize: 'small', fontWeight: '700' },
                      }}
                      primary="Change Password"
                    />
                  </StyledMenuItem>
                )}
                <StyledMenuItem onClick={logout}>
                  <ListItemText
                    primaryTypographyProps={{
                      style: { fontSize: 'small', fontWeight: '700' },
                    }}
                    primary="Logout"
                  />
                </StyledMenuItem>
                <StyledMenuItem
                  disabled
                  style={{ backgroundColor: 'lightgrey' }}
                >
                  <ListItemText
                    color="primary"
                    primaryTypographyProps={{
                      style: {
                        fontSize: 'small',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'end',
                      },
                    }}
                    primary={`Version : ${npmPackage.version} | ${manifest.version}`}
                  />
                </StyledMenuItem>
              </StyledMenu>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <StyledMenu
        id="simple-menu"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        anchorEl={menuDrawer}
        open={Boolean(menuDrawer)}
        onClose={handleMenuClose}
        MenuListProps={{ onMouseLeave: handleMenuClose }}
      >
        {menuList}
      </StyledMenu>

      {/* {checkUserHasAccessForPath('settings', 'read') && ( */}
      <StyledMenu
        id="settings-menu"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        anchorEl={settingsMenuDrawer}
        open={Boolean(settingsMenuDrawer)}
        onClose={handleSetingsMenuClose}
        MenuListProps={{ onMouseLeave: handleSetingsMenuClose }}
      >
        {hasSettingsMenuAccess(
          PRODUCTS.MAINAPP,
          loggedInUserInfo?.roles?.sso_title,
        ) && (
          <span>
            <StyledMenuItem onClick={() => pushSettingsMenu('/branding')}>
              <ListItemText primary="Branding" />
            </StyledMenuItem>
            <StyledMenuItem onClick={() => pushSettingsMenu('/domains')}>
              <ListItemText primary="Domain Management" />
            </StyledMenuItem>
            <StyledMenuItem onClick={() => pushSettingsMenu('/users')}>
              <ListItemText primary="Users" />
            </StyledMenuItem>
          </span>
        )}
        {loggedInUserInfo?.roles?.sso_title === ROLES.PLATFORM_ADMIN && (
          <>
            <StyledMenuItem onClick={() => pushSettingsMenu('/import')}>
              <ListItemText primary="Import" />
            </StyledMenuItem>
            <StyledMenuItem onClick={() => pushSettingsMenu('/users')}>
              <ListItemText primary="Users" />
            </StyledMenuItem>
          </>
        )}
      </StyledMenu>
      {/* )} */}

      {/* Analytics menu */}
      <StyledMenu
        id="analytics-menu"
        anchorEl={analyticsMenuDrawer}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={Boolean(analyticsMenuDrawer)}
        onClose={handleAnalyticsMenuClose}
        MenuListProps={{ onMouseLeave: handleAnalyticsMenuClose }}
      >
        <StyledMenuItem onClick={() => props.history.push('/events')}>
          <ListItemText primary="Events" />
        </StyledMenuItem>
      </StyledMenu>
      <Container className={classes.content}>
        {props.children}
        <SubmitSnackbar />
      </Container>
      <>
        <Dialog
          open={pwdChange}
          fullWidth
          maxWidth="xs"
          onClose={hideModalWindow_pwdChange}
          PaperProps={{
            style: { borderRadius: 20 },
          }}
        >
          <DialogTitle onClose={hideModalWindow_pwdChange}>
            Change Password
          </DialogTitle>
          <DialogContent>
            <ChangePasswordPage />
          </DialogContent>
        </Dialog>
        {/* Report download notification snackbar */}
        <Snackbar
          style={{ width: '300px' }}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={snacksOpen}
          onClose={handleSnacksClose}
          message={snacksMsg}
          action={action}
        />
      </>
    </div>
  );
};

export default withRouter(MiniDrawer);
